import { Component, Input } from '@angular/core'

import { Overview } from '../../overview.model'

@Component({
  selector: 'product-summary',
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss'],
})
export class ProductSummaryComponent {
  @Input()
  overviewModel: Overview
}
